import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { COLLECTION_IDS } from "../../../shared/config/collections.js";
import { createAppApi } from "../../../shared/lib/store/createAppApi.js";
import { PerxisService } from "../../../shared/services/perxis/index.js";
import { dataFormatter } from "../../../shared/store/config/lib/dataFormatter.js";
import { getExtendedItems } from "../../../shared/store/reference/lib/getExtendedItems.js";
import "@perxis-auto/shared";
import "../../../shared/store/reference/model/index.js";
import "@perxis-auto/shared/lib/lib/instanceOf";
import { FormatterDataTypeEnum } from "../../../shared/types/formatter.js";
import { name } from "../config/name.js";
const api = createAppApi({
  reducerPath: name,
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getVehicles: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.findPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.vehiclesVehicles
        });
        const { items, total } = response;
        const extVehicleItems = await getExtendedItems(api2, items, {
          fields: referenceFields
        });
        const formattedExtVehicleItems = dataFormatter(
          api2,
          FormatterDataTypeEnum.Vehicle,
          extVehicleItems
        );
        return {
          data: {
            total,
            items: formattedExtVehicleItems
          }
        };
      }
    }),
    getVehicle: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        var _a;
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.getPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.vehiclesVehicles
        });
        const { item } = response;
        if (!item) {
          return { data: null };
        }
        const [extVehicleItem] = await getExtendedItems(api2, [item], {
          fields: referenceFields
        });
        const isExtendOptions = Boolean((_a = extVehicleItem == null ? void 0 : extVehicleItem.data.options) == null ? void 0 : _a.length);
        if (isExtendOptions) {
          const optionsToItems = extVehicleItem.data.options.map(
            (option) => ({
              data: { ...option, group: { ...option.group } }
            })
          );
          const extendedOptionItems = await getExtendedItems(api2, optionsToItems, {
            fields: ["group"]
          });
          extVehicleItem.data.options = extendedOptionItems.map((option) => option.data);
        }
        const formattedExtVehicleItem = dataFormatter(
          api2,
          FormatterDataTypeEnum.Vehicle,
          extVehicleItem
        );
        return {
          data: formattedExtVehicleItem
        };
      }
    })
  })
});
const {
  reducer,
  reducerPath,
  useGetVehicleQuery,
  useGetVehiclesQuery,
  useLazyGetVehicleQuery,
  useLazyGetVehiclesQuery
} = api;
export {
  api,
  reducer,
  reducerPath,
  useGetVehicleQuery,
  useGetVehiclesQuery,
  useLazyGetVehicleQuery,
  useLazyGetVehiclesQuery
};
